import { useCallback, useEffect, useState } from 'react';
import { DEFAULT_FLAGS, loadSiteSettings, saveSiteSettings } from '../utils/siteSettings';

export default function useSiteSettings() {
  const [settings, setSettings] = useState({
    ...DEFAULT_FLAGS,
    roadmapDone: {},
    goalsDone: {},
    loading: true,
  });

  const refresh = useCallback(async () => {
    try {
      const next = await loadSiteSettings();
      setSettings({ ...next, loading: false });
    } catch {
      setSettings((prev) => ({ ...prev, loading: false }));
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const update = useCallback(async (partial) => {
    setSettings((prev) => ({ ...prev, ...partial }));
    await saveSiteSettings(partial);
    await refresh();
  }, [refresh]);

  return { settings, loading: settings.loading, update, refresh };
}
